import React, { useEffect, useState } from "react";
import {
  Grid,
  Button,
  Typography,
  Modal,
  Fade,
  Input,
} from "@material-ui/core";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import CustomInput from "../../Components/CustomInput";
import Backdrop from "@material-ui/core/Backdrop";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { green } from "@material-ui/core/colors";
import { useHistory, useLocation } from "react-router";
import AuthClient from "../../Service/auth_services";
import { useDispatch } from "react-redux";
import logo from "../../Images/logo.png";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import FormHelperText from "@material-ui/core/FormHelperText";
import { showSnackbar } from "../../Components/Snackbar/SnackbarActions";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 20,
    },
    paper: {
      backgroundColor: "#fff",
      boxShadow: theme.shadows[5],
      padding: 20,
      textAlign: "center",
    },
  })
);
const ChangePassword = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  console.log(location.search);

  const [password, setPassword] = useState("");
  const [nPassword, setNPassword] = useState("");
  const [open, setOpen] = React.useState(false);
  const [error, setError] = useState<boolean>(false);
  const [showPasswordFlag, setShowPasswordFlag] = useState<boolean>(false);
  const [submitClickFlag, setSubmitClickFlag] = useState<boolean>(false);
  const [showConfirmPasswordFlag, setShowConfirmPasswordFlag] =
    useState<boolean>(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const setInputState = (inputStateValue: any, inputId: any) => {
    inputId == "password" && setPassword(inputStateValue);
    inputId == "nPassword" && setNPassword(inputStateValue);
  };
  const forgotPasswordLogic = (e: any) => {
    e.preventDefault();
    var flag = true;
    if (password == "") {
      flag = false;
    } else if (nPassword == "") {
      flag = false;
    } else if (password != nPassword) {
      flag = false;
    }
    if (flag) {
      setSubmitClickFlag(false);
      AuthClient.updatePassword({
        password: password,
        password_confirmation: nPassword,
      })
        .then((response: any) => {
          console.log(response);
          forgotPasswordLogicSuccess(response);
        })
        .catch((error) => {
          dispatch(showSnackbar("error", error.errors.full_messages));
        });
    } else {
      setSubmitClickFlag(true);
    }
  };

  const forgotPasswordLogicSuccess = (response: any) => {
    console.log(response);
    dispatch(showSnackbar("Success", ["Password set successfully"]));
    setTimeout(() => {
      history.replace({ pathname: "/auth/login", state: { subPage: "login" } });
    }, 5000);
  };
  const handleClose = () => {
    setOpen(false);
    history.push("/auth/login", { subPage: "login" });
  };
  const handleClickShowPassword = () => {
    setShowPasswordFlag(!showPasswordFlag);
  };

  const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (location.search !== "") {
      var session =
        sessionStorage.length > 0
          ? JSON.parse(sessionStorage.authorization_headers)
          : null;
      let searchParams = new URLSearchParams(location.search);
      // console.log((session.uid))
      var pdata = {
        "access-token": searchParams.get("access-token"),
        "cache-control": session?.["cache-control"],
        client: searchParams.get("client"),
        "content-type": session?.["content-type"],
        expiry: session?.["expiry"],
        "token-type": session?.["token-type"],
        uid: searchParams.get("uid"),
      };
      sessionStorage.clear();
      sessionStorage.removeItem("authorization_headers");

      sessionStorage.setItem("authorization_headers", JSON.stringify(pdata));
    }
  }, []);

  return (
    <div>
      <form onSubmit={forgotPasswordLogic}>
        <Grid container direction="row" justify="center">
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <img src={logo} alt="Acuity" />
          </Grid>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Typography
              variant="h1"
              style={{ marginTop: 20, color: "#4D4F5C" }}
            >
              Set Password
            </Typography>
          </Grid>

          <Grid item xs={12} style={{ marginTop: 20 }}>
            <CustomInput
              id="password"
              placeholder="Password"
              autoFocus
              name="Password"
              // autoComplete="off"
              helperText={
                submitClickFlag && password == ""
                  ? "Please enter  Password"
                  : ""
              }
              error={submitClickFlag && password == "" ? true : false}
              parentcall={setInputState}
              type={showPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword((prevState) => !prevState)}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} style={{ marginTop: 20 }}>
            <CustomInput
              id="nPassword"
              placeholder="Confirm Password"
              name="nPassword"
              helperText={
                submitClickFlag && nPassword == ""
                  ? "Please enter Confirm Password"
                  : ""
              }
              error={submitClickFlag && nPassword == "" ? true : false}
              parentcall={setInputState}
              type={showConfirmPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        setShowConfirmPassword((prevState) => !prevState)
                      }
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {password != nPassword && submitClickFlag && (
            <FormHelperText className="Mui-error">
              Password and confirm password are not matched
            </FormHelperText>
          )}

          <Grid
            item
            xs={6}
            justify="center"
            alignContent="center"
            style={{ marginTop: 20, textAlign: "center" }}
          >
            <Button
              disableElevation
              type="submit"
              variant="contained"
              color="primary"
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
      <Modal
        disableBackdropClick
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div>
              <CheckCircleIcon style={{ color: green[500], fontSize: 40 }} />
            </div>
            <Typography
              variant="subtitle1"
              style={{ color: "#4D4F5C", marginTop: 20, marginBottom: 30 }}
            >
              Password changed successfully!
            </Typography>
            <Button disableElevation variant="outlined" onClick={handleClose}>
              {" "}
              Login
            </Button>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default ChangePassword;
